<template>
    <div class="group-description" id="AboutMe">
        <div class="group-left">
            <img src="../../assets/aboutmeImg.jpg" alt="">
        </div>
        <div class="group-right">
            <div class="group-up">
                <h1>Sobre mi</h1>
            </div>
            <div class="group-down">
                <div class="group-down-text">
                    <p>Soy Lidia Holgado Romero, tengo 26 años y actualmente he terminado el Grado Superior de Desarrollo de Aplicaciones Web en Medac Sevilla, con el propósito de consolidar mi carrera como desarrolladora web.</p>
                    <p>Cuento con una titulación previa como Técnico Superior en Animaciones 3D, Juegos y Entornos Interactivos, lo que ha proporcionado una base sólida para mi formación. Además, he complementado mi aprendizaje con diversos cursos autodidactas a través de plataformas como Udemy, OpenBootCamp y OpenWebinars.</p>
                    <p>Soy una persona apasionada por la informática, con un enfoque específico en el desarrollo web. Mi motivación principal es alcanzar metas y objetivos profesionales que me permitan crecer y desarrollarme en este campo.</p>
                    <p>Mi interés y entusiasmo se centran especialmente en el ámbito de la web development, donde aspiro a aplicar mis habilidades y conocimientos de manera creativa. Estoy ansiosa por encontrar oportunidades laborales que me permitan contribuir al mundo digital y seguir evolucionando en mi carrera profesional.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
</script>

<style scoped>
    .group-description{
        font-family: Roboto;
        display: grid;
        grid-template-columns: 1fr 1fr;
        width: 100%;
    }
    .group-left{
        display: flex;
        flex-direction:column;
        justify-content: center;
        align-items: center;
        background-color: #faf3e1;

        animation: appear-left linear;
        animation-timeline: view();
        animation-range: entry 0% cover 40%;

        img{
            width: 75%;
            border-radius: 1em;
        }
    }

    .group-right{
        display: flex;
        flex-direction:column;
        justify-content: center;
        align-items: center;
        background-color: #faf3e1;

        animation: appear-right linear;
        animation-timeline: view();
        animation-range: entry 0% cover 40%;
    }
    .group-up{
        h1{
            font-size: 3em;
            margin: 0;
        }
    }

    .group-down{
        font-size: 1.2em;
        margin-top: 3em;
        width: 60%;
    }

   
    @keyframes appear-left{
        from{
            opacity: 0;
            scale: 0.5;
            transform: translateX(-100%);
        }
        to{
            opacity: 1;
            scale: 1;
            transform: translateX(0%);
        }
    }

    @keyframes appear-right{
        from{
            opacity: 0;
            scale: 0.5;
            transform: translateX(-100%);
        }
        to{
            opacity: 1;
            scale: 1;
            transform: translateX(0%);
        }
    }

</style>